import router from '../../router'
import { State, ServerResponse, ErrorResponse } from '../types/auth'

export const state: State = {
  loading: false,
  isLoggedIn: localStorage.getItem("token") || "",
  user: [],
  users: [],
  // @ts-ignore: Object is possibly 'null'.
  permissions: localStorage.getItem("userPermissions") ? localStorage.getItem("userPermissions").split(",") : [],
  errors: [],
  msg: "",
}

// getters
const getters = {
  getLoading: function(state: State): boolean { return state.loading },
  getErrors: function(state: State): Array<string> { return state.errors },
  getUsers: function(state: State): any { return state.users },
  getMsg: function(state: State): string { return state.msg },
  isLoggedIn: function(state: State): string { return state.isLoggedIn },
  getPermissions: function(state: State): [] { return state.permissions },
}

// actions
const actions = {
  login: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridgeLogin', payload)
        .then(function(response: ServerResponse) {
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('userPermissions', response.data.permissions)
          commit('setLoggedIn', response.data.token)
          commit('setUser', response.data.user)
          commit('setPermissions', response.data.permissions);
          commit('setLoading', false)
          router.push({ name: 'Bridge' })
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', error.response.data.msg)
        })
  },
  logout: function ({commit}: {commit: Function}) {
    localStorage.removeItem("token")
    localStorage.removeItem("userPermissions")
    commit('setLoggedIn', "");
    commit('setPermissions', []);
    commit('setUser', []);
    commit('setLoading', false);
    router.push('/login')
  },
  getUsers: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/getUsers', payload)
        .then(function(response: any) {
          commit('setLoading', false)
          commit('setUsers', response.data.users);
        })
        .catch(function(error: any) {
          commit('setLoading', false)
          commit('setUsers', []);
          commit('setMsg', error.response.data.msg)
        })
  },
  getUser: function({commit}: {commit: Function}): void {
    commit('setLoading', true)
    axios.get(process.env.VUE_APP_TRAFFIC_API+'api/getUser')
        .then(function(response: any) {
          commit('setLoading', false)
          commit('setPermissions', response.data.permissions);
        })
        .catch(function(error: any) {
          commit('setLoading', false)
          //commit('setUsers', []);
          //commit('setMsg', error.response.data.msg)
        })
  },

}

const mutations = {
  setLoading: function(state: State, payload: boolean): void { state.loading = payload },
  setLogout: function(state: State, payload: string): void { state.isLoggedIn = payload },
  setLoggedIn: function(state: State, payload: string): void { state.isLoggedIn = payload },
  setPermissions: function(state: State, payload: []): void { state.permissions = payload },
  setUser: function(state: State, payload: object): void { state.user = payload },
  setUsers: function(state: State, payload: any): void { state.users = payload },
  setErrors: function(state: State, payload: []): void { state.errors = payload },
  setMsg: function(state: State, payload: string): void { state.msg = payload },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
